//-----------------thanos26 API (the only backend)-----------------
// Set at build time: locally in .env.development(.local), for deployments as pipeline variables (see README)
const thanos26BaseUrl = process.env.REACT_APP_THANOS26_API_BASE_URL || "";
const thanos26Scope = process.env.REACT_APP_THANOS26_API_SCOPE || "";

// The base url must end with "/", otherwise new URL(path, base) drops the "api" segment
export const THANOS26_API_BASE_URL = thanos26BaseUrl && !thanos26BaseUrl.endsWith("/") ? `${thanos26BaseUrl}/` : thanos26BaseUrl;
export const THANOS26_API_SCOPES = thanos26Scope ? [thanos26Scope] : [];
